import { Button } from "@/src/components/ui/button";
import { FETCH_BASE_URL } from "@/src/lib/fetch";
import { DownloadIcon } from "lucide-react";

export function ExportLocationsButton() {
  return (
    <a href={FETCH_BASE_URL + "/api/locations/locations.csv"} download>
      <Button size="sm" variant="link">
        <DownloadIcon className="mr-2 h-4 w-4" />
        Export CSV
      </Button>
    </a>
  );
}
